import Regulations_table_one from "./regulations_table_one";
import React from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Regulations_table_two from "./ragulations_table_two";
import Regulations_Notes from "./Regulations_Notes";
import Warnings from "./warnings";
export default function Reguletions(){
    return (
      <div>
        <p className="page_headers  font-semibold text-start pt-2 header_color">
          REGULATION
        </p>
        <div className="py-6">
          <Regulations_table_one />
        </div>
        <hr />
        {/* <div className="py-6" >
                   <Regulations_table_two/>
                   </div> */}
        <div className=" non_table_block_padding py-6">
          <Warnings />
        </div>
        {/* <div className="py-6">
                    <Regulations_Notes/>
                   </div> */}
        <div></div>
      </div>
    );
}

